import { Component, Input } from "@angular/core";

@Component({
  selector: "delivery-mode",
  styleUrls: ["./delivery-mode.component.css"],
  templateUrl: "./delivery-mode.component.html"
})
export class DeliveryModeComponent {
  @Input()
  deliveryMode!: string;
}